import { render, staticRenderFns } from "./ContentFeedSettings.vue?vue&type=template&id=32fea16b&scoped=true"
import script from "./ContentFeedSettings.vue?vue&type=script&lang=js"
export * from "./ContentFeedSettings.vue?vue&type=script&lang=js"
import style0 from "./ContentFeedSettings.vue?vue&type=style&index=0&id=32fea16b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fea16b",
  null
  
)

export default component.exports